import {
  datadogRum,
  type RumActionEventDomainContext,
  type RumEvent,
  type RumInitConfiguration,
} from '@datadog/browser-rum';

import { maskTokenQuery } from '@/utils/maskTokenQuery';

const maskTokenQueryInRumEvent = (event: RumEvent) => {
  event.view.url = maskTokenQuery(event.view.url);
  if (event.view.referrer) {
    event.view.referrer = maskTokenQuery(event.view.referrer);
  }
  if (event.type === 'resource') {
    event.resource.url = maskTokenQuery(event.resource.url);
  }
  if (event.type === 'error' && event.error.resource) {
    event.error.resource.url = maskTokenQuery(event.error.resource.url);
  }
};

export const datadogRumInit: () => void = () => {
  const applicationId =
    import.meta.env.VITE_DATADOG_APPLICATION_ID ||
    'VITE_DATADOG_APPLICATION_ID';
  const clientToken =
    import.meta.env.VITE_DATADOG_CLIENT_TOKEN || 'VITE_DATADOG_CLIENT_TOKEN';
  const env = import.meta.env.VITE_SITE_ENV || 'local';
  const version = import.meta.env.VITE_BUILD_VERSION || '1.0.0';

  const options: RumInitConfiguration = {
    site: 'datadoghq.com',
    service: 'parents-web',
    applicationId,
    clientToken,
    env,
    version,
    sessionSampleRate: 10,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask',
    beforeSend: (event, context) => {
      maskTokenQueryInRumEvent(event);
      if (event.type === 'action' && event.action && event.action.target) {
        const targetName = (context as RumActionEventDomainContext).events
          ?.map((event) => (event.target as Element).className)
          .find((className) => !!className);
        event.action.target.name = targetName || 'Some Elements';
      }
      return true;
    },
  };

  if (env !== 'production') return;
  datadogRum.init(options);
};
